import { env } from 'config/environment'
import { useEffectOnce } from 'hook/useEffectOnce'

// Блокирует зум страницы через ctrl/cmd + колесо мыши (а также pinch-zoom на трекпаде,
// который браузер эмулирует событием wheel с ctrlKey), а также через клавиатуру
// (ctrl/cmd + "+" / "-" / "=" / "0").
export const usePreventZoom = (active = true): void => {
  useEffectOnce(() => {
    if (!active || env.development) return

    const onWheel = (event: WheelEvent) => {
      if (event.ctrlKey || event.metaKey) {
        event.preventDefault()
      }
    }

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey || event.metaKey) {
        if (['+', '-', '=', '_', '0'].includes(event.key)) {
          event.preventDefault()
        }
      }
    }

    window.addEventListener('wheel', onWheel, { passive: false })
    window.addEventListener('keydown', onKeyDown)

    return () => {
      window.removeEventListener('wheel', onWheel)
      window.removeEventListener('keydown', onKeyDown)
    }
  })
}
